import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardContent,
  LinearProgress,
  Grid,
  TextField,
  Stack,
  CardHeader,
  CardActions,
} from "@mui/material";
import { Image, Save } from "@mui/icons-material";
import BackLink from "../shared/BackLink";
import { useDb } from "../../contexts/DatabaseContext";
import FileUploader from "../shared/FileUploader";

const EditPost = () => {
  const { postId } = useParams();
  const navigate = useNavigate();
  const { getSingleDoc, updateDocument } = useDb();
  const [loading, setLoading] = useState(true);
  const [postData, setPostData] = useState(null);

  useEffect(() => {
    const fetchPostData = async () => {
      try {
        const docData = await getSingleDoc("posts", postId);
        console.log("Fetched post data:", docData); // Log fetched post data
        setPostData(docData);
      } catch (error) {
        console.error("Error fetching post data:", error);
      }
      setLoading(false);
    };

    fetchPostData();
  }, [getSingleDoc, postId]);

  // @ts-ignore
  const handleChange = (e, index) => {
    const { name, value } = e.target;
    // @ts-ignore

    setPostData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileUploadUrl = (url, name) => {
    setPostData((prevData) => ({
      ...prevData,
      [name]: url,
    }));
  };

  const handleSave = async () => {
    try {
      await updateDocument("posts", postId, postData);
      console.log("Post data updated successfully!");
      navigate("/post");
    } catch (error) {
      console.error("Error updating post data:", error);
    }
  };

  if (loading) {
    return <LinearProgress />;
  }

  if (!postData) {
    return null;
  }

  console.log(postData);

  return (
    <div>
      <h1>Edit Post</h1>
      <BackLink />

      <Card sx={{ mt: 1 }}>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Stack spacing={2}>
                <TextField
                  name="title"
                  label="Post Title"
                  variant="outlined"
                  fullWidth
                  value={postData.title}
                  onChange={(e) => handleChange(e, "title")}
                />
                <TextField
                  name="subtitle"
                  label="Sub Title"
                  variant="outlined"
                  fullWidth
                  value={postData.subtitle}
                  onChange={(e) => handleChange(e, "subtitle")}
                />
                <TextField
                  name="bodyText"
                  label="Body Text"
                  variant="outlined"
                  fullWidth
                  value={postData.bodyText}
                  onChange={(e) => handleChange(e, "bodyText")}
                />
                <Card>
                  <CardHeader
                    title="Header Image"
                    avatar={<Image />}
                    action={<Button>Change Image</Button>}
                  />
                  <CardContent>
                    <img src={postData.headerImage} width={"100%"} />
                  </CardContent>
                  <CardActions>
                    <FileUploader
                      getUrl={(url) => handleFileUploadUrl(url, "headerImage")}
                      name={"headerImage"}
                      label={"Header Image"}
                    />
                  </CardActions>
                </Card>
              </Stack>
            </Grid>
            <Grid item xs={12} md={6}>
              <Card>
                <CardHeader title="Main Image" avatar={<Image />} />
                <CardContent>
                  <img src={postData.secondaryImage} width={"100%"} />
                </CardContent>
                <CardActions>
                  <FileUploader
                    getUrl={(url) => handleFileUploadUrl(url, "secondaryImage")}
                    name={"secondaryImage"}
                    label={"Main Image"}
                  />
                </CardActions>
              </Card>
            </Grid>

            <Grid item xs={12}>
              <Button
                variant="contained"
                color="primary"
                startIcon={<Save />}
                onClick={handleSave}
                fullWidth
              >
                Update Post
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </div>
  );
};

export default EditPost;
